import React from 'react'
import { FormCheckbox, FormCheckboxProps } from './FormCheckbox'
import { SelectOption } from '@campus/graphql/schema/graphql'

type FormCheckboxesProps = Partial<FormCheckboxProps> & { value: SelectOption[] }

export const FormCheckboxes: React.FC<FormCheckboxesProps> = ({ name, value, ...props }) => {
  return <>
    { value.map((option) => <FormCheckbox
      {...props}
      key={option.value}
      id={`${name}-${option.value}`}
      name={name}
      label={option.label}
      value={option.value}
    />) }
  </>
}

export default FormCheckboxes
